import * as qiniu from 'qiniu-js'
import apiClient from 'modules/apiClient';


/**
 *判断当前环境
*/
let isInMp = false
window.wx.miniProgram.getEnv((res) => {
  //res.miniprogram == true  表示处在小程序环境中;(但是在浏览器中，并不会进回调!!!!!)
  if(res.miniprogram) {
    isInMp = true
  }else {
  }
})

function getIsMp() {
  return isInMp;
};
var ua = window.navigator.userAgent,
isWindowsPhone = /(?:Windows Phone)/.test(ua),
isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
isAndroid = /(?:Android)/.test(ua),
isFireFox = /(?:Firefox)/.test(ua),
isChrome = /(?:Chrome|CriOS)/.test(ua),
isTable = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
isiPhone = /(?:iPhone)/.test(ua) && !isTable,
isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
isPc = !isiPhone && !isAndroid && !isSymbian,
isReactNative = !!window['ReactNativeWebView'],
isWeixin = !!/micromessenger/.test(ua.toLowerCase())
export const uaEnv = {
  isWechatMp: getIsMp,
  isTable: isTable,
  isiPhone: isiPhone,
  isIOS,
  isAndroid: isAndroid,
  isReactNative,
  isPc: isPc,
  isWeixin
};
console.log('UA:', ua, uaEnv)

export function postMessage(obj:Object | string) {
  if(isReactNative) {
    if(typeof obj == 'string') {
      // @ts-ignore;
      window.ReactNativeWebView.postMessage(obj)
    }else {
      // @ts-ignore;
      window.ReactNativeWebView.postMessage(JSON.stringify(obj))
    }
  }
  
}





const UPLOAD_HOST = 'https://up.qiniup.com';

export function requestPayment(params) {
  return new Promise<any>((resolve, reject) => {
    window.wx.chooseWXPay({
      ...params,
      success(res) {
        resolve(res);
      },
      fail(res) {
        reject(res);
      }
    });
  });
}


export async function qiniuUploader(file) {
  return new Promise(async(resolve, reject) => {
    const { body } = await apiClient.base.file()
    let token = body.token
    let key = body.key

    let pathArr=file.type.split("/")
    let pathLast=pathArr[pathArr.length-1]
    const observable = qiniu.upload(file, key+'.'+pathLast, token, {}, {
      // region: 'z0',
      // domain: 'https://assets.gongji58.com/', // // bucket 域名，下载资源时用到。如果设置，会在 success callback 的 res 参数加上可以直接使用的 ImageURL 字段。否则需要自己拼接
      // 以下方法三选一即可，优先级为：uptoken > uptokenURL > uptokenFunc
      // uptoken: token, // 由其他程序生成七牛 uptoken
      // uptokenURL: 'UpTokenURL.com/uptoken', // 从指定 url 通过 HTTP GET 获取 uptoken，返回的格式必须是 json 且包含 uptoken 字段，例如： {"uptoken": "[yourTokenString]"}
      // uptokenFunc: function() {return '[yourTokenString]';}
    })
    observable.subscribe({
      next(res){
        // ...
        // console.log('next', res)
      },
      error(err){
        // ...
        // console.log('err', err)
        reject('')
      },
      complete(res){
        // ...
        // console.log('res', res)
        resolve('https://assets.gongji58.com/'+res.key)
      }
    })
  })
}


export function formatDate(date,fmt){
  // if(/(y+)/.test(fmt)){
      const DT= new Date(date);  //接收毫秒级时间戳
      let ret;
      const opt = {
          "y+": DT.getFullYear().toString(),        // 年
          "m+": (DT.getMonth() + 1).toString(),     // 月
          "d+": DT.getDate().toString(),            // 日
          "H+": DT.getHours().toString(),           // 时
          "M+": DT.getMinutes().toString(),         // 分
          "S+": DT.getSeconds().toString()          // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
              fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
          //padStart: ES2017补全方法
      };
      return fmt;
  // }
};